import { LOCALIZED_INSPIRATION_BLOG_SLUGS } from '~/constants/inspirationBlogSlug';

export function isInspirationsBlogUrl(url: string): boolean {
  return LOCALIZED_INSPIRATION_BLOG_SLUGS.some(slug => url.includes(slug));
}
